import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    Programme,
    ProgramTemplate,
    ProjectProgramFloor,
    ProjectProgramTask,
    TaskLibrary,
    ProgramChartData,
    ProgramChartFloor,
    ProgramChartTask,
} from "../Types/Project/DefaultService/ProgramInterface";

interface ProgrammeState {
    programme: Programme | null;
    taskLibrary: TaskLibrary[];
    projectProgramFloor: ProjectProgramFloor[];
    projectProgramTask: ProjectProgramTask[];
    loading: boolean;
    error: string | null;
    selectedTaskLibrary: TaskLibrary | null;
    selectedProjectProgramFloor: ProjectProgramFloor | null;
    selectedProjectProgramTask: ProjectProgramTask | null;

    loadingProgramTemplate: boolean;
    errorProgramTemplate: string | null;
    programTemplates: ProgramTemplate[];

    loadingProgramChartData: boolean;
    programChartData: ProgramChartData | null;
    programChartFloor: ProgramChartFloor[];
    programChartTask: ProgramChartTask[];
    errorProgramChartData: string | null;
}

const initialState: ProgrammeState = {
    programme: null,
    taskLibrary: [],
    projectProgramFloor: [],
    projectProgramTask: [],
    loading: false,
    error: null,
    selectedTaskLibrary: null,
    selectedProjectProgramFloor: null,
    selectedProjectProgramTask: null,

    loadingProgramTemplate: false,
    errorProgramTemplate: null,
    programTemplates: [],

    loadingProgramChartData: false,
    programChartData: null,
    programChartFloor: [],
    programChartTask: [],
    errorProgramChartData: null
}

const programmeSlice = createSlice({
    name: 'programmes',
    initialState,
    reducers: {
        fetchProgrammeStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchProgrammeSuccess: (state, action: PayloadAction<Programme | null>) => {
            state.loading = false;
            if (action.payload) {
                state.programme = action.payload;
                state.taskLibrary = action.payload.task_library ? action.payload.task_library : [];
                state.projectProgramFloor = action.payload.floors ? action.payload.floors : [];
                state.projectProgramTask = action.payload.tasks ? action.payload.tasks : [];
            }
        },
        fetchProgrammeFailure: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = action.payload;
        },

        /* For program template */
        fetchProgramTemplateStart: (state) => {
            state.loadingProgramTemplate = true;
            state.errorProgramTemplate = null;
        },
        fetchProgramTemplateSuccess: (state, action: PayloadAction<ProgramTemplate[]>) => {
            state.loadingProgramTemplate = false;
            if (action.payload) {
                state.programTemplates = action.payload;
            }
        },
        fetchProgramTemplateFailure: (state, action: PayloadAction<string>) => {
            state.loadingProgramTemplate = false;
            state.errorProgramTemplate = action.payload;
        },

        /* For program chart */
        fetchProgramChartStart: (state) => {
            state.loadingProgramChartData = true;
            state.errorProgramChartData = null;
        },
        fetchProgramChartSuccess: (state, action: PayloadAction<ProgramChartData | null>) => {
            state.loadingProgramChartData = false;
            if (action.payload) {
                state.programChartData = action.payload;
                state.programChartFloor = action.payload.floor_chart ? action.payload.floor_chart : [];
                state.programChartTask = action.payload.task_chart ? action.payload.task_chart : [];
            }
        },
        fetchProgramChartFailure: (state, action: PayloadAction<string>) => {
            state.loadingProgramChartData = false;
            state.errorProgramChartData = action.payload;
        },
    }
});

export const {
    fetchProgrammeStart,
    fetchProgrammeSuccess,
    fetchProgrammeFailure,
    fetchProgramTemplateStart,
    fetchProgramTemplateSuccess,
    fetchProgramTemplateFailure,
    fetchProgramChartStart,
    fetchProgramChartFailure,
    fetchProgramChartSuccess
} = programmeSlice.actions;
export default programmeSlice.reducer;